import { render, staticRenderFns } from "./departmentCompletion.vue?vue&type=template&id=5234b2bb&scoped=true"
import script from "./departmentCompletion.vue?vue&type=script&lang=js"
export * from "./departmentCompletion.vue?vue&type=script&lang=js"
import style0 from "./departmentCompletion.vue?vue&type=style&index=0&id=5234b2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234b2bb",
  null
  
)

export default component.exports